export const BYTES_PER_KILOBYTE = 1024;

export const bytesToString = (bytes: number, formatDecimalPlaces = 2): string => {
    if (bytes <= 0) {
        return '0B';
    }
    const units = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const index = Math.floor(Math.log(bytes) / Math.log(BYTES_PER_KILOBYTE));
    return `${(bytes / Math.pow(BYTES_PER_KILOBYTE, index)).toFixed(formatDecimalPlaces)}${units[index]}`;
};
